export default "/37471c9f5ff7576f48ca6299a67147db.jpg";